<template>
    <v-card class="overflow-hidden v-card v-sheet theme--light m-0">
        <!-- Alert message -->
        <div>
            <v-alert :type="alert_type" :model-value="alert" :value="alert" transition="scale-transition">{{alert_message}}</v-alert>
        </div>
        <!-- Title-->
        <div style="max-height: 108px;">
            <header-component :headerTitle="headerText"  :router-link="getRouterLink" :router-link-text="getRouterLinkText" :return-condition="true" :component-name="componentsName"/>
        </div>
        <!-- filter data popup -->
        <v-row justify="center">
            <v-dialog content-class="filter-data" v-model="filterPopup" persistent :max-width="filter_width">
                <v-card style="max-width: 100% !important;" class="filter_ui">
                    <v-card-text class="pb-0">
                        <v-row class="pt-5">
                            <v-text-field color="primary" prepend-inner-icon="mdi-magnify" v-model="prd_number"  label="PRD Number" class="ma-2" variant="outlined" style="max-width: 300px;"></v-text-field>
                            <v-text-field color="primary" prepend-inner-icon="mdi-magnify" v-model="reasonRefDocNo"  label="Inward Reason Reference Document Number" class="ma-2" variant="outlined" style="max-width: 300px;"></v-text-field>
                            <v-text-field color="primary" prepend-inner-icon="mdi-magnify" v-model="RefDocNo"  label="Inward Reference Document Number" class="ma-2" variant="outlined" style="max-width: 300px;"></v-text-field>
                            <v-text-field color="primary" prepend-inner-icon="mdi-magnify" v-model="tag_id"  label="Tag ID" class="ma-2" variant="outlined" style="max-width: 300px;"></v-text-field>
                        <!-- </v-row>
                        <v-row> -->
                            <v-text-field color="primary" prepend-inner-icon="mdi-magnify" v-model="article_id"  label="Article ID" class="ma-2" variant="outlined" style="max-width: 300px;"></v-text-field>
                            <v-text-field color="primary" prepend-inner-icon="mdi-magnify" v-model="serial_no"  label="Serial Number" class="ma-2" variant="outlined" style="max-width: 300px;"></v-text-field>
                            <v-autocomplete color="primary" prepend-inner-icon="mdi-magnify" v-model="irrd_type"  :items = "irrdType_list" item-title = "name" item-value = "id" label="IRRD Type" class="ma-2" variant="outlined" style="max-width: 300px;"></v-autocomplete>
                            <v-autocomplete color="primary" prepend-inner-icon="mdi-magnify" v-model="initiators"  :items = "initiator_list" item-title = "username" item-value = "id" label="Initiator" class="ma-2" variant="outlined" multiple style="max-width: 300px;" v-if="active_tab == 'Approval'"></v-autocomplete>
                            <v-autocomplete color="primary" prepend-inner-icon="mdi-magnify" v-model="approval_locations"  :items = "approval_location_list" item-title = "code" item-value = "id" label="Location Code" class="ma-2" variant="outlined" multiple style="max-width: 300px;"  v-if="active_tab == 'Approval'"></v-autocomplete>
                        </v-row>
                        <v-card-actions class="margin-10">
                            <v-spacer></v-spacer>
                            <v-btn size="small" variant="outlined" color="primary" class="text-none" @click="filterPopup = false">Cancel</v-btn>
                            <v-btn size="small" variant="flat" color="primary" class="text-none" @click="applyFilterFunc">Apply Filter(S)</v-btn>
                        </v-card-actions>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-row>
        <!-- ird number dropdown popup -->
        <v-row justify="center">
            <v-dialog v-model="irdPopUp" persistent :max-width="ird_width">
                <v-card class="v-card-100">
                    <v-card-title class="d-flex align-center">
                        <span>Create IRD</span>
                        <v-spacer></v-spacer>
                        <v-btn variant="solo" icon @click="irdPopUp = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-card-title>
                    <v-divider :thickness="4" class="m-0" />
                    <v-card-text class="d-flex mt-6">
                        <v-autocomplete prepend-inner-icon="mdi-magnify" label="IRRD NUMBER" :items ="irrdList" v-model="irrd_selected"  item-title = "inward_reason_reference_document_number" item-value = "id" variant="outlined" :loading="autoLoad"  style="max-width: 400px;"></v-autocomplete>
                        <v-btn color="primary" class="mt-2 ml-8 text-none" :disabled="!irrd_selected" @click="showDataByIrd">G0</v-btn>
                    </v-card-text>
                    <v-card-text v-if="irrdTableData" class="px-0 pb-0">
                        <v-layout column>
                            <v-flex md6 style="overflow: auto">
                                <v-list-item-content class="pl-2 pr-2">
                                    <v-data-table hover
                                        density="compact" 
                                        disable-pagination 
                                        :hide-default-footer="true"
                                        :headers="irrdHeaders" 
                                        :items="irrd_table_data"
                                        :items-per-page="pageSize"
                                        fixed-header
                                        height = "300px"
                                        style="max-height:300px; overflow-y: scroll;"
                                        class="elevation-1">
                                        <template #[`item.received_quantity`]="{ item }">
                                            <v-text-field v-model="item.received_quantity" @keydown="onKeyDown(item)" placeholder="Enter QTY"></v-text-field>
                                        </template>
                                        <template #bottom></template>
                                    </v-data-table>
                                </v-list-item-content>
                            </v-flex>
                        </v-layout>
                        <!-- <a @click="addMoreColumn" style="text-decoration:underline; color:#007BFF; margin: 12px;">
                            <span v-if="view_more">View Less</span>
                            <span v-else>View ALL</span>
                        </a> -->
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn class="cancel-color ma-2 text-none"  variant="outlined" color="primary"  @click="irdPopUp = false">Cancel</v-btn>
                                <v-btn class="ma-2 text-none" variant="flat" color="primary" :disabled="submitDisabled" @click="createIrd">Submit</v-btn>
                                <v-spacer></v-spacer>
                            </v-card-actions>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-row>
        <!-- Excel Upload popup -->
        <v-row justify="center">
            <v-dialog v-model="excelUploadPopup" persistent max-width="424px">
            <v-card class="v-card-100">
                <v-card-title class="d-flex align-center">
                    <span>Create PRD</span>
                    <v-spacer></v-spacer>
                    <v-btn variant="solo" icon @click="cancelUploadFile">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-divider :thickness="4" class="m-0" />
            <v-card-text>
                <v-container>
                    <v-file-input
                        v-model="upload_file"
                        label="Attach PRD Csv file"
                        @change="changeFile"
                        style="margin-top: 28px;"
                        accept=".csv"
                        >
                    </v-file-input>
                    <div v-if="uploading">
                        Uploading file ({{ uploadPercentage }}%)
                        <v-progress-linear
                        :value="uploadPercentage"
                        color="blue"
                        height="10"
                        ></v-progress-linear>
                    </div>
                </v-container>
            </v-card-text>
            <v-card-actions center>
                <v-spacer></v-spacer>
                    <v-btn :color="!upload_file ? 'secondry' : 'primary'" class="mb-3  text-none" v-if="this.confirmButton != 'FINISH'" @click="uploadFile" :disabled="!upload_file">Confirm</v-btn>
                    <v-btn :color="!upload_file || number>0 ? 'secondry' : 'primary'" class="mb-3 text-none" v-if="this.confirmButton == 'FINISH'" @click="confirmUploadFile" :disabled="!upload_file || number>0">Finish</v-btn>
                    <v-btn variant="outlined" color="primary" class="cancel-color mb-3 text-none" @click="cancelUploadFile">Cancel</v-btn>   
                <v-spacer></v-spacer>
            </v-card-actions>
            </v-card>
            </v-dialog>
        </v-row>
        <!-- Manual Creation popup -->
        <v-row justify="center">
            <v-dialog v-model="manualCreationPopup" persistent max-width="700px">
            <v-card class="v-card-100">
                <v-card-title class="d-flex align-center">
                    <span>Create PRD</span>
                    <v-spacer></v-spacer>
                    <v-btn variant="solo" icon @click="closeManualcreation">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-divider :thickness="4" class="m-0" />
            <v-card-text style="padding: 0px 20px;">
                <v-container>
                    <v-row>
                        <v-col cols="12" sm="5" md="6">
                            <v-text-field color="primary" v-model="articleId" label="Article ID" variant="outlined" style="margin-bottom: 0px !important;"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="5" md="6">
                            <v-text-field color="primary" v-model="serialNo" label="Serial Number" variant="outlined" style="margin-bottom: 0px !important;"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="5" md="6">
                            <v-text-field color="primary" v-model="quantity" label="Quantity" variant="outlined" style="margin-bottom: 0px !important;" type="number"></v-text-field>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions center>
                <v-spacer></v-spacer>
                    <v-btn variant="outlined" color="primary" class="cancel-color mb-3 text-none" @click="closeManualcreation">Cancel</v-btn>
                    <v-btn :color="articleId=='' || serialNo =='' || quantity =='' ? 'secondry' : 'primary'" :disabled="articleId=='' || serialNo =='' || quantity ==''" class="cancel-color mb-3 text-none" @click="submitManualCreation">Submit</v-btn>   
                <v-spacer></v-spacer>
            </v-card-actions>
            </v-card>
            </v-dialog>
        </v-row>
        <!--Approve Ok confirm popup -->
        <v-row justify="center">
            <v-dialog v-model="okapproveconfirmpopup" persistent max-width="424px">
            <v-card>
                <v-card-title class="d-flex" v-if="action_name == 'success' || action_name == 'deletion_reject'">
                    <v-spacer></v-spacer>
                    <v-btn variant="solo" icon @click="approvalConfirmationCancel">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card class="v-card-100"  v-if="action_name == 'delete' || action_name == 'deletion_approval'">
                    <v-card-title class="d-flex align-center">
                        <span v-if="action_name == 'deletion_approval'">Remarks</span>
                        <span v-if="action_name == 'delete'">Reason For Deletion</span>
                        <v-spacer></v-spacer>
                        <v-btn variant="solo" icon @click="approvalConfirmationCancel">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-card-title>
                </v-card>
                <v-card-text class="text-center">
                     <span v-if="action_name == 'success' || action_name == 'deletion_reject'"> {{message}} </span>
                     <span v-if="action_name == 'deletion_approval'">
                        <v-text-field color="primary" label="Enter the remarks" v-model="deletion_remarks" variant="outlined" class="mt-7"></v-text-field>
                     </span>
                     <span v-if="action_name == 'delete'">
                        <v-text-field color="primary" label="Enter reason for deleting this PRD" v-model="deletion_remarks" variant="outlined" class="mt-7"></v-text-field>
                     </span>
                </v-card-text>
                <v-card-actions center v-if="confirmedClicked == false">
                    <v-spacer></v-spacer>
                    <v-btn :color="action_name != 'deletion_reject' && !deletion_remarks ? 'secondry' : 'primary'" variant="flat" class="mb-3 text-none" @click="approvalCinfirmed" :disabled="action_name != 'deletion_reject' && !deletion_remarks">Confirm</v-btn>
                    <v-btn variant="outlined" color="primary" class="cancel-color mb-3 text-none" @click="approvalConfirmationCancel">Cancel</v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
                <v-card-actions v-if="confirmedClicked">
                    <v-spacer></v-spacer>
                    <v-btn color="primary" variant="flat" class="mb-3 text-none" @click="okClicked">Ok</v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
            </v-dialog>
        </v-row>

        <!-- Approval Approve Popup -->
        <v-row justify="center">
            <v-dialog v-model="openApprovelPopup" persistent max-width="424px">
                <v-card class="v-card-100">
                    <v-card-title class="d-flex">
                        <v-spacer></v-spacer>
                        <v-btn icon @click="openApprovelPopup = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-card-title>
                    <v-card-text class="text-center">
                        <span>Do you want to write off?</span>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" variant="flat" class="mb-3 text-none" outlined @click="closeApprovalPopup('debitNote')">Yes</v-btn>
                        <v-btn color="primary" variant="outlined" class="mb-3 text-none" @click="closeApprovalPopup('writeOff')">No</v-btn>
                        <v-spacer></v-spacer>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
        <!-- Raise Claim Popup -->
        <v-row justify="center">
            <v-dialog v-model="openRaiseClaimPopup" persistent max-width="424px">
                <v-card class="v-card-100">
                    <v-card-title class="d-flex">
                        <v-spacer></v-spacer>
                        <v-btn icon @click="openRaiseClaimPopup = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-card-title>
                    <v-card-text class="text-center">
                        <span>Do you want to raise claim?</span>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" variant="flat" class="mb-3 text-none" outlined @click="raiseClaimYes">Yes</v-btn>
                        <v-btn color="primary" variant="outlined" class="mb-3 text-none" @click="closeApprovalPopup('raiseClaim')">No</v-btn>
                        <v-spacer></v-spacer>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
        <!-- Debit Note Popup -->
        <v-row justify="center">
            <v-dialog v-model="openDebitNotePopup" persistent max-width="530px">
                <v-card class="v-card-100">
                    <v-card class="v-card-100">
                        <v-card-title class="d-flex">
                            <span></span>
                            <v-spacer>Debit Note</v-spacer>
                            <v-btn icon @click="openDebitNotePopup = false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-card-title>
                    </v-card>
                    <v-card-text class="text-center pb-0 pt-5">
                        <v-row>
                            <v-col cols="6">
                                <v-text-field label="Enter the Vendor Code" v-model="enterd_vendor_code" variant="outlined"/>
                            </v-col>
                            <v-col cols="6">
                                <v-text-field label="Enter the Debit Amount(₹)" v-model="debit_note_amount" variant="outlined"  type="number"/>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" variant="outlined" class="mb-3 text-none" outlined @click="openDebitNotePopup = false">Cancel</v-btn>
                        <v-btn color="primary" variant="flat" class="mb-3 text-none" @click="closeApprovalPopup('debitNote')" :disabled="!enterd_vendor_code || !debit_note_amount" >Submit</v-btn>
                        <v-spacer></v-spacer>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>

        <v-card class="v-card-100 mb-6">
            <v-tabs color="primary" v-model="tab_index">
                <v-tab  class="component-tab-heading" ripple @click="loadData(tab,'tab_clicked', index)" style="text-transform:none!important;
                text-decoration: none; padding-top: 4px;" v-for="(tab, index) in tabs" :key="`${tab+index}`"> {{tab}}</v-tab>
            </v-tabs>
        </v-card>
        <v-card-title style="padding: 25px 25px 15px 15px;" class="action-style pb-1">
        <v-row>
            <v-autocomplete class="SelectItem m-3"  label="Select Field" v-model="selected_field" variant="outlined" :items="fieldlist" style="max-width: 150px; margin-right: 12px;" v-if="active_tab != 'Approval'"></v-autocomplete>
            <v-text-field class="SearchItem m-3"  color="primary" label="Search"  prepend-inner-icon="mdi-magnify" v-model="search_tag" v-no-edge-space style="max-width: 300px;" variant="outlined" @keyup.enter="loadData(active_tab)" :disabled="!selected_field && active_tab != 'Approval'"></v-text-field>
            <v-spacer></v-spacer>
            <div style="margin-bottom: 10px;">
            <v-btn :disabled="selected.length == 0" color="primary" class="ma-2 mt-4 text-none" v-if="active_tab == 'Incomplete PRDs' && (isActionAllowed(role) || currentUser.roles.includes('warehouse_manager'))" @click="download_incomplete_file" style="min-height: 56px" >Download</v-btn>
            <v-btn color="primary" style="min-height: 56px" class="ma-2 mt-4 text-none" v-if="active_tab == 'Incomplete PRDs'  && (isActionAllowed(role) || currentUser.roles.includes('warehouse_manager'))" @click="itemIrrdDetailpopup([],'upload_prd')">Upload</v-btn>
            <v-btn color="primary" style="min-height: 56px" class="ma-2 mt-4  text-none" v-if="active_tab == 'Incomplete PRDs'   && (isActionAllowed(role) || currentUser.roles.includes('warehouse_manager'))" @click="itemIrrdDetailpopup([],'create_prd')">Create <br class="text-break"> PRD</v-btn>
            <v-btn color="primary" style="min-height: 56px" class="ma-2 mt-4  text-none" v-if="active_tab == 'Incomplete PRDs' && (isActionAllowed(role) || currentUser.roles.includes('warehouse_manager'))" @click="creatPRD('IRD Number')">Create <br class="text-break"> IRD</v-btn>
            <v-btn :disabled="selected.length == 0" color="primary" style="min-height: 56px" @click="deleteItem" class="ma-2  mt-4  text-none" v-if="(active_tab == 'Incomplete PRDs' || active_tab == 'Open PRDs')  && (isActionAllowed(role)|| currentUser.roles.includes('warehouse_manager'))">Delete</v-btn>
            <v-btn 
                :disabled="isOpenEditButtonDisabled" 
                style="min-height: 56px" color="primary" 
                @click="openEditSerialNumberPopup"
                class="ma-3 mb-0  text-none" 
                v-if="isEditButtonAllowed"
              >Edit</v-btn>
            <v-btn  color="primary" style="min-height: 56px" class="ma-2  mt-4  text-none" :disabled="selected.length == 0" v-if="active_tab == 'Approval' && currentUser.roles.includes('admin') && (isActionAllowed(role) || currentUser.roles.includes('warehouse_manager'))" @click="closeApprovalPopup('debitNote')">Approve</v-btn>
            <v-btn color="primary" style="min-height: 56px" class="ma-2 mt-4  text-none" :disabled="selected.length == 0" v-if="active_tab == 'Approval' && currentUser.roles.includes('admin')  && (isActionAllowed(role) || currentUser.roles.includes('warehouse_manager'))" @click="OpenReject">Reject</v-btn>
            </div>
            <!-- Filter -->
            <v-expansion-panels class="custom-control_outlined ma-0 pt-4" ref="filterPopupRef" readonly style="max-width: 250px; margin-bottom: 18px; height: 56px;" v-if="active_tab != 'Pending For Approval'">
                <v-expansion-panel variant="outlined" @click="filterListOfButtons" >
                    <v-expansion-panel-title>Filter
                    </v-expansion-panel-title>
                </v-expansion-panel>
            </v-expansion-panels>
        </v-row>
        
        <!-- search, filter, Action buttons -->
        <!-- <v-card class="v-card-100">
            <v-card-title style="padding: 12px 24px 4px 24px;"> -->
            <!-- Search fields -->
            <!-- <v-text-field prepend-inner-icon="mdi-magnify" v-model="search_tag" label="Search" style="max-width: 300px;" outlined v-on:keyup.enter="loadData()" ></v-text-field> -->
            <!-- <v-spacer></v-spacer> -->
            <!-- Actions buttons -->
            <!-- <v-actions style="margin-bottom: 28px;display: flex;">
                <div class="text-center mt-2 mr-2">
                    <v-menu offset-y>
                        <template v-slot:activator="{ on, attr }">
                            <v-btn color="primary" v-on="on" v-bind="attr">
                            Create PRD
                            <v-icon dark>
                                mdi-menu-down
                            </v-icon>
                            </v-btn>
                        </template>
                        <v-list>
                            <v-list-item v-for="(item, index) in prdList"
                            @click="creatPRD(item)" :key="index">
                            <v-list-item-title>{{ item }}</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </div>
                <v-btn class="ma-2" :disabled="selected.length == 0" color="primary" @click="deleteItem">Delete</v-btn>
            </v-actions> -->
            
            <!-- Filter -->
                <!-- <v-expansion-panels class="custom-control_outlined ml-2" ref = "filterPopupRef" readonly style="max-width: 300px; margin-bottom: 28px; min-height: 56px;">
                    <v-expansion-panel outlined @click="filterListOfButtons" >
                        <v-expansion-panel-header>Filter
                            <template v-slot:actions>
                                <v-icon color="primary">
                                mdi-menu-down
                                </v-icon>
                            </template>
                        </v-expansion-panel-header>
                    </v-expansion-panel>
                </v-expansion-panels> -->
            <!-- </v-card-title>
        </v-card> -->
        <!--Return request sub id data popup-->
        <v-row justify="center">
                <v-dialog v-model="dataDetailPopup" persistent max-width="700px">
                    <v-card class="v-card-100">
                        <v-card-title class="d-flex align-center ">
                            <span>Return Sub-Request ID "{{ returnRequestId }}"</span>
                            <v-spacer></v-spacer>
                            <v-btn variant="solo" icon @click="dataDetailPopup=false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-card-title>
                        <v-divider :thickness="4" class="m-0" />
                    <v-card-text>
                        <v-container>
                            <div class="itemPopUp">
                                <v-row>
                                    <v-col cols="6" >
                                        <span style="font-weight: 500;">Type Of Request</span>
                                    </v-col>
                                    <v-col cols="6">
                                        {{ item_details.return_type ? item_details.return_type : 'N/A'}}
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="6" >
                                        <span style="font-weight: 500;">Article ID</span>
                                    </v-col>
                                    <v-col cols="6">
                                        {{ item_details.sku_code ? item_details.sku_code : 'N/A'}}
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="6" >
                                        <span style="font-weight: 500;">PRD Creation Date</span>
                                    </v-col>
                                    <v-col cols="6">
                                        {{ item_details.created_date ? item_details.created_date : 'N/A'}}
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="6" >
                                        <span style="font-weight: 500;">Internal Reason Ref Doc Num</span>
                                    </v-col>
                                    <v-col cols="6">
                                        {{ item_details.irrd_number ? item_details.irrd_number : 'N/A'}}
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="6" >
                                        <span style="font-weight: 500;">Internal Ref Doc Num</span>
                                    </v-col>
                                    <v-col cols="6">
                                        {{ item_details.ird_number ? item_details.ird_number : 'N/A'}}
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="6" >
                                        <span style="font-weight: 500;">Serial Number</span>
                                    </v-col>
                                    <v-col cols="6">
                                        {{ item_details.serial_number_1 ? item_details.serial_number_1 : 'N/A'}}
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="6" >
                                        <span style="font-weight: 500;">Tag ID</span>
                                    </v-col>
                                    <v-col cols="6">
                                        {{ item_details.tag_number ? item_details.tag_number : 'N/A'}}
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="6" >
                                        <span style="font-weight: 500;">Box ID</span>
                                    </v-col>
                                    <v-col cols="6">
                                        {{ item_details.box_number ? item_details.box_number : 'N/A'}}
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="6" >
                                        <span style="font-weight: 500;">Pickup Location</span>
                                    </v-col>
                                    <v-col cols="6">
                                        {{ item_details.pickup_location ? item_details.pickup_location : 'N/A'}}
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="6" >
                                        <span style="font-weight: 500;">Delivery Location</span>
                                    </v-col>
                                    <v-col cols="6">
                                        {{ item_details.delivery_location ? item_details.delivery_location : 'N/A'}}
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="6" >
                                        <span style="font-weight: 500;">Suggested Pick Up Date</span>
                                    </v-col>
                                    <v-col cols="6">
                                        {{ item_details.suggested_pickup_date ? item_details.suggested_pickup_date : 'N/A'}}
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="6" >
                                        <span style="font-weight: 500;">Logistics Partner</span>
                                    </v-col>
                                    <v-col cols="6">
                                        {{ item_details.logistic_partner ? item_details.logistic_partner : 'N/A'}}
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="6" >
                                        <span style="font-weight: 500;">Status</span>
                                    </v-col>
                                    <v-col cols="6">
                                        {{ item_details.status ? item_details.status : 'N/A'}}
                                    </v-col>
                                </v-row>
                                <v-row class="mt-3">
                                    <v-col cols="6" >
                                        <span style="font-weight: 700;">PRICING DETAILS</span>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="6" >
                                        <span style="font-weight: 500;">ASP (Of Item To Be Returned)</span>
                                    </v-col>
                                    <v-col cols="6">
                                        {{ item_details.asp ? item_details.asp : 'N/A'}}
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="6" >
                                        <span style="font-weight: 500;">Sales Price (Of Item To Be Returned)</span>
                                    </v-col>
                                    <v-col cols="6">
                                        {{ item_details.purchase_price ? item_details.purchase_price : 'N/A'}}
                                    </v-col>
                                </v-row>
                                <v-row class="mt-2">
                                    <v-col cols="6">
                                        <a @click="conditionDetails" style="color: #1976d2;text-decoration: underline;"> Click Here For Condition Details</a>
                                    </v-col>
                                </v-row>
                            </div>
                        </v-container>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-row>
        <!--Condition data popup-->
        <v-row justify="center">
                <v-dialog v-model="conditionPopup" persistent max-width="700px">
                    <v-card class="v-card-100">
                        <v-card-title class="d-flex align-center">
                            <v-btn variant="solo" icon @click="backToRequestpage">
                                <v-icon>mdi-arrow-left</v-icon>
                            </v-btn>
                            <span class="ml-4">Condition Details "{{ returnRequestId }}"</span>
                            <v-spacer></v-spacer>
                            <v-btn variant="solo" icon @click="conditionPopup=false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-card-title>
                        <v-divider :thickness="4" class="m-0" />
                    <v-card-text>
                        <v-container>
                            <div class="itemPopUp">
                                <v-row>
                                    <v-col cols="6" >
                                        <span style="font-weight: 500;">Packaging  Condition</span>
                                    </v-col>
                                    <v-col cols="6">
                                        {{ item_details.sku_code ? 'N/A' : 'N/A'}}
                                        <a style="color: #1976d2;text-decoration: underline; margin-left: 12px;">View Image(s)</a>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="6" >
                                        <span style="font-weight: 500;">Item Condition</span>
                                    </v-col>
                                    <v-col cols="6">
                                        {{ item_details.sku_code ? 'N/A' : 'N/A'}}
                                        <a style="color: #1976d2;text-decoration: underline;margin-left: 12px;">View Image(s)</a>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="6" >
                                        <span style="font-weight: 500;">Item Powering On?</span>
                                    </v-col>
                                    <v-col cols="6">
                                        {{ item_details.sku_code ? 'N/A' : 'N/A'}}
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="6" >
                                        <span style="font-weight: 500;">Freezer Working?</span>
                                    </v-col>
                                    <v-col cols="6">
                                        {{ item_details.sku_code ? 'N/A' : 'N/A'}}
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="6" >
                                        <span style="font-weight: 500;">Insulator Working?</span>
                                    </v-col>
                                    <v-col cols="6">
                                        {{ item_details.sku_code ? 'N/A' : 'N/A'}}
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="6" >
                                        <span style="font-weight: 500;">Light Working?</span>
                                    </v-col>
                                    <v-col cols="6">
                                        {{ item_details.sku_code ? 'N/A' : 'N/A'}}
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="6" >
                                        <span style="font-weight: 500;">Closing Properly?</span>
                                    </v-col>
                                    <v-col cols="6">
                                        {{ item_details.sku_code ? 'N/A' : 'N/A'}}
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="6" >
                                        <span style="font-weight: 500;">Door Intact?</span>
                                    </v-col>
                                    <v-col cols="6">
                                        {{ item_details.sku_code ? 'N/A' : 'N/A'}}
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="6" >
                                        <span style="font-weight: 500;">Accessories Attached?</span>
                                    </v-col>
                                    <v-col cols="6">
                                        {{ item_details.sku_code ? 'N/A' : 'N/A'}}
                                    </v-col>
                                </v-row>
                            </div>
                        </v-container>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-row>
        <!-- Serial number popup -->
        <v-row justify="center" ref="reserveLotForm">
            <v-dialog v-model="updateSerialNumberPopup" persistent max-width="600px">
                <v-card class="v-card-100">
                    <v-card-title class="d-flex">
                        <span>{{ selected && selected[0] && selected[0].irrd_type == 'Replacement Order' ? 'Edit' : 'Update Serial Number'}}</span>
                        <v-spacer></v-spacer>
                        <v-btn icon @click="closeUpdateSerialNumberPop"><v-icon>mdi-close</v-icon> </v-btn>
                    </v-card-title>
                    <v-container v-if="selected && selected[0] && selected[0].irrd_type == 'Replacement Order'">
                        <v-row>
                            <v-col cols="2" sm="6" md="6">
                                <v-text-field label="Article ID" variant="outlined" v-model="article_id_edit" type="text"></v-text-field>
                            </v-col>
                             <v-col cols="2" sm="6" md="6">
                                <v-text-field label="Map (₹)" variant="outlined" v-model="format_map_price" type="text"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row v-if="!(selected && selected[0] && selected[0].irrd_type == 'Replacement Order' && selected[0].scan_indicator === 'f')">
                         <v-col cols="2" sm="6" md="6">
                                <v-text-field label="Serial Number1" variant="outlined" v-model="serial_number1" type="text"></v-text-field>
                            </v-col>
                            <v-col cols="2" sm="6" md="6">
                                <v-text-field label="Serial Number 2" variant="outlined" v-model="serial_number2" type="text"></v-text-field>
                            </v-col>                           
                        </v-row>
                        <v-row v-if="!(selected && selected[0] && selected[0].irrd_type == 'Replacement Order' && selected[0].scan_indicator === 'f')">
                            <v-col cols="2" sm="6" md="6">
                                <v-file-input accept="image/*" label="Upload Box S/N Image" variant="outlined" prepend-icon="" append-inner-icon="mdi-paperclip" v-model="box_sn_image" clearable = "false" :disabled="selected.length && selected[0].serial_number1 == serial_number1">
                                </v-file-input>
                                <span v-if="box_sn_image" class="file_name_css">{{ box_sn_image.name.length > 20  ? box_sn_image.name.slice(0,20) + '...' : box_sn_image.name }} <span class="cursor-pointer mx-2" @click="box_sn_image = null">x</span></span>
                            </v-col>
                            <v-col cols="3" sm="6" md="6">
                                <v-file-input accept="image/*" label="Upload Product S/N Image" variant="outlined" prepend-icon="" append-inner-icon="mdi-paperclip" v-model="product_sn_image" clearable = "false" :disabled="selected.length && selected[0].serial_number2 == serial_number2"/>
                                <span v-if="product_sn_image" class="file_name_css">{{ product_sn_image.name.length > 20  ? product_sn_image.name.slice(0,20) + '...' : product_sn_image.name }} <span class="cursor-pointer mx-2" @click="product_sn_image = null">x</span></span>
                            </v-col>  
                        </v-row>
                    </v-container>
                    <v-container v-else>
                        <v-row>
                            <v-col cols="2" sm="6" md="6">
                                <v-text-field label="Serial Number 1" variant="outlined" v-model="serial_number1" type="text"></v-text-field>
                            </v-col>
                            <v-col cols="3" sm="6" md="6">
                                <v-text-field label="Serial Number 2" variant="outlined" v-model="serial_number2" type="text"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="2" sm="6" md="6">
                                <v-file-input accept="image/*" label="Upload Box S/N Image" variant="outlined" prepend-icon="" append-inner-icon="mdi-paperclip" v-model="box_sn_image" clearable = "false" :disabled="selected.length && selected[0].serial_number1 == serial_number1">
                                </v-file-input>
                                <span v-if="box_sn_image" class="file_name_css">{{ box_sn_image.name.length > 20  ? box_sn_image.name.slice(0,20) + '...' : box_sn_image.name }} <span class="cursor-pointer mx-2" @click="box_sn_image = null">x</span></span>
                            </v-col>
                            <v-col cols="3" sm="6" md="6">
                                <v-file-input accept="image/*" label="Upload Product S/N Image" variant="outlined" prepend-icon="" append-inner-icon="mdi-paperclip" v-model="product_sn_image" clearable = "false" :disabled="selected.length && selected[0].serial_number2 == serial_number2"/>
                                <span v-if="product_sn_image" class="file_name_css">{{ product_sn_image.name.length > 20  ? product_sn_image.name.slice(0,20) + '...' : product_sn_image.name }} <span class="cursor-pointer mx-2" @click="product_sn_image = null">x</span></span>
                            </v-col>  
                        </v-row>
                    </v-container>
                    <v-card-text> </v-card-text>
                    <v-card-actions style="justify-content: center;">
                        <v-btn size="small" variant="flat" color="normal"  class="mb-3 text-none" @click="closeUpdateSerialNumberPop">Cancel</v-btn>
                        <v-btn size="small" variant="flat" color="primary" class="mb-3 text-none" @click="updateSerialNumber" :disabled="isButtonDisabled">Submit</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
    </v-card-title>
            <!-- Data Table -->
            <v-layout column>
                <v-flex md6 style="overflow: auto">
                    <v-data-table hover
                        density="compact" 
                        :search="search" 
                        v-model="selected" 
                        show-select
                        disable-pagination 
                        :hide-default-footer="true"
                        :headers="computedHeaders" 
                        :items="table_data"
                        :items-per-page="pageSize"
                        :loading="loading" 
                        fixed-header
                        height="100%"
                        loading-text="Loading Data... Please wait"
                        class="elevation-1"
                        return-object
                        >
                        <template v-slot:[`item.${header.key}`]="{ item }" v-for="header in headers" :key="header.key">
                            <span v-if="header.key == 'return_sub_request_id'">
                                <a href="#" @click.prevent="itemSubRequestDetailpopup(item)" style="text-decoration: underline !important; color: #1976d2 !important; cursor: pointer !important;">{{ item.return_sub_request_id }}</a>
                            </span> 
                            <span v-else-if="header.key == 'irrd_number'">
                                <a href="#" @click.prevent="itemIrrdDetailpopup(item,'IRRD')" style="text-decoration: underline !important; color: #1976d2 !important; cursor: pointer !important;">{{ item.irrd_number }}</a>
                            </span> 
                            <span v-else-if="header.key == 'ird_number'">
                                <a href="#" @click.prevent="itemIrrdDetailpopup(item,'IRD')" style="text-decoration: underline !important; color: #1976d2 !important; cursor: pointer !important;">{{ item.ird_number }}</a>
                            </span> 
                            <span v-else-if="header.key == 'action'">
                                <v-btn outlined class="cancel-color my-1 text-none" :disabled="$isRelianceClient() ? Completedisabled : !Completedisabled"  color="primary" @click="itemIrrdDetailpopup(item,'Incomplete PRDs')">Complete PRD</v-btn>
                            </span>
                            <span v-else-if="header.key == 'is_error'">
                                <span v-if="!item.is_error" style="color:#1e7b1e;">No Error</span>
                                <span v-else style="color:red;">Error</span>                            
                            </span>
                            <span v-else-if="header.key !== 'images' && item[header.key]">
                                <span v-tooltip="item[header.key]">
                                {{ item[header.key].length > 20 ? item[header.key].slice(0, 20) + '...' : item[header.key] }}
                                </span>
                            </span>
                           <span v-else>-</span>
                        </template>

                        <!-- <template #[`item.return_sub_request_id`]="{ item }">
                            <span v-if="item.return_sub_request_id">
                                <a @click="itemSubRequestDetailpopup(item)" style="color: #1976d2;">{{ item.return_sub_request_id }}</a>
                            </span>
                            <span v-else>-</span>
                        </template> -->
                        <!-- <template #[`item.irrd_number`]="{ item }">
                            <span v-if="item.irrd_number"><a @click="itemIrrdDetailpopup(item,'IRRD')" style="color: #1976d2;"><span>{{ item.irrd_number }}</span></a>
                            </span>
                            <span v-else>-</span>
                        </template>
                        <template #[`item.ird_number`]="{ item }">
                            <span v-if="item.ird_number"><a @click="itemIrrdDetailpopup(item,'IRD')" style="color: #1976d2;"><span>{{ item.ird_number }}</span></a>
                            </span>
                            <span v-else>-</span>
                        </template> -->
                        <!-- <template #[`item.action`]="{ item }">
                            <v-btn outlined class="cancel-color my-1 text-none" :disabled="organization_name == 'Reliance' ? Completedisabled : !Completedisabled"  color="primary" @click="itemIrrdDetailpopup(item,'Incomplete PRDs')">Complete PRD</v-btn>
                        </template>
                        <template #[`item.is_error`]="{ item }">
                            <span v-if="item.is_error" style="color:#1e7b1e;">No Error</span>
                            <span v-else style="color:red;">Error</span>
                        </template> -->
                        <!-- <template #[`item.irrd_type`]="{ item }">
                        <span class="text-none">{{ item.irrd_type ? item.irrd_type : "-" }}</span>
                        </template>

                        <template #[`item.ird_type`]="{ item }">
                            <span class="text-none">{{ item.ird_type ? item.ird_type : "-" }}</span>
                        </template> -->
                        <!-- <template v-slot:item.irrd_number="{ item }">
                            <span>{{ item.irrd_number ? item.irrd_number : "N/A" }}</span>
                        </template> -->
                        <!-- <template #[`item.return_sub_request_id`]="{ item }">
                            <a @click="itemSubRequestDetailpopup(item)" style="color: #1976d2;"><span>{{ item.return_sub_request_id ? item.return_sub_request_id : "N/A" }}</span>                       <u> {{ item.tag_number }}</u>
                            </a>
                        </template> -->
                        <template #bottom></template>
                    </v-data-table>
                </v-flex>
            </v-layout>

            <!-- pagination display -->
            <PaginationComponent
                    :pageSize="pageSize"
                    :pageSizes="pageSizes"
                    :totalCount="totalCount"
                    :selected="selected"
                    :page="page"
                    :totalPages="totalPages"
                    @update:pageSize="handlePageSizeChange"
                    @update:page="handlePageChange"
                    class="mt-2 mb-0"
                />
    </v-card>
</template>

<script>
import $ from 'jquery';
import HeaderComponent from "./../../../commoncomponents/HeaderComponent";
import { defaultPageSize, defaultPageSizes } from '@/components/commoncomponents/PaginationComponent.vue';
// import { moduleAccessFunc,module_that_allowed,signout } from '@/backend/axios/moduleAccess'
import { moduleAccessFunc,module_that_allowed,signout,isOnlyViewAction } from '@/backend/axios/moduleAccess'

export default {
    components: {
    HeaderComponent
    },
    data(){
            return{
                headerText : "PRD",
                tab_index: 0,
                search_tag:'',
                alert_type:'',
                alert : false,
                alert_message : '',
                tabs : ["Incomplete PRDs", "Open PRDs", "Approval", "Pending For Approval"],
                loading: false,
                table_data: [],
                page: 1,
                totalPages: 1,
                totalCount: '',
                pageSize: defaultPageSize,
                pageSizes: defaultPageSizes,
                selected:[],
                search:'',
                filterPopup: false,
                loading: false,
                headers: [],
                prdList : ["Excel Upload","Manual Creation"],
                subRequestId : '',
                reasonRefDocNo : '',
                RefDocNo: '',
                status : '',
                message : '',
                okapproveconfirmpopup : false,
                confirmedClicked : false,
                excelUploadPopup : false,
                upload_file : '',
                uploading: false,
                confirmButton:'CONFIRM',
                uploadPercentage: 0,
                manualCreationPopup : false,
                serialNo : '',
                articleId : '',
                quantity : '',
                item_details : [],
                dataDetailPopup: false,
                conditionPopup: false,
                irrdType_list : [],
                returnRequestId : '',
                number : 0,
                isFiltering : false,
                filterPage : 1,
                active_tab : "Incomplete PRDs",
                irdPopUp : false,
                irrd_selected : '',
                irrdList : [],
                irrdTableData : false,
                ird_width : "624px",
                irrdHeaders : [],
                irrd_table_data : '',
                view_more : false,
                action_name : '',
                prd_number: '',
                tag_id: '',
                article_id: '',
                serial_no : '',
                irrd_type: '',
                deletion_remarks : '',
                autoLoad: false,
                updateSerialNumberPopup: false,
                serial_number1:'',
                serial_number2:'',
                organization_name:'',
                openApprovelPopup : false,
                openRaiseClaimPopup : false,
                openDebitNotePopup : false,
                debit_note_amount : '',
                enterd_vendor_code : '',
                currentUser: {},
                Completedisabled: true,
                selected_field : null,
                fieldlist : ['PRD No.','IRD No.', 'Serial Number'],
                role:'',
                article_id_edit:'',
                map_edit:'',
                filter_width : '950px',
                componentsName : '',
                getRouterLinkText : '',
                getRouterLink : '',
                box_sn_image: null,
                product_sn_image: null,
                initiator_list: [],
                approval_location_list : [],
                initiators: null,
                approval_locations: null
            }
        },
    async created(){
        this.role = this.$store.state.currentUser.roles[0]
        if(this.role in module_that_allowed && moduleAccessFunc(this.role,'PRD')){
            signout()
            return;
        }
        this.message = this.$store.state.alert_message;
        this.organization_name = this.$store.state.organization_name;
        this.currentUser = this.$store.state.currentUser;
        this.pending_app_item = this.$store.state.pending_approval_item
        if(this.pending_app_item && this.pending_app_item.type_of_approval == 'Delete PRD'){
            this.componentsName = 'PRD',
            this.getRouterLinkText = 'Pending Approval',
            this.getRouterLink = { name : 'physicalinspectionApproval'}
        } else {
            this.componentsName = '',
            this.getRouterLinkText = '',
            this.getRouterLink = ''
        }
        if(this.message){
            this.action_name = 'success';
            this.okapproveconfirmpopup = true;
            this.confirmedClicked = true;
            this.$store.commit("showMessage",{alert_type : '',alert_message : ''});
        }
        const tab = this.$store.state.active_tab
        if(this.$store.state.tab_name === 'Incomplete' || tab == 'Incomplete PRDs'){
            this.tab_index = 0
            this.loadData("Incomplete PRDs",'tab_clicked');
        }else if(this.$store.state.tab_name === 'Open' || tab == 'Open PRDs'){
            this.tab_index = 1
            this.loadData("Open PRDs",'tab_clicked');
            // this.$store.commit("setPrdDetails", {tab_name:  JSON.stringify([])});
        }else if(this.$store.state.tab_name === 'Approval' || tab == 'Approval'){
            this.tab_index = 2
            this.loadData("Approval",'tab_clicked');
            // this.$store.commit("setPrdDetails", {tab_name:  JSON.stringify([])});
        }else{
            this.loadData("Incomplete PRDs",'tab_clicked');
        }
        this.$store.state.tab_name = ''
        this.scrollToTOp();
        this.getFilterData();
        this.getInitiorsData()
        this.getApprovalLocation()
    },
    computed :{
        isButtonDisabled() {
            if(!this.selected.length) return false
            if(this.selected && this.selected[0] && this.selected[0].irrd_type == 'Replacement Order' && this.selected[0].scan_indicator === 'f'){
                const first = this.selected[0];
                const isReplacementOrder = first.irrd_type === 'Replacement Order';
                const isScanIndicatorF = first.scan_indicator === 'f';
                const mandatoryFieldsFilled = !!this.article_id_edit && !!this.map_edit;
                return !(isReplacementOrder && isScanIndicatorF && mandatoryFieldsFilled);
            }else{
            const box_num_changed =!!this.serial_number1 && this.serial_number1 != this.selected[0].serial_number1
            const prod_num_changed =!!this.serial_number2 && this.serial_number2 != this.selected[0].serial_number2
            const hasScanIndicator = this.selected && this.selected[0] && this.selected[0].scan_indicator === 't';
            console.log(this.serial_number1 ,this.selected[0].serial_number1, this.serial_number2, this.selected[0].serial_number2, box_num_changed, prod_num_changed, this.box_sn_image, this.product_sn_image)
            const condition = !this.article_id_edit || !this.map_edit || this.number || 
            (
                ((!this.box_sn_image && box_num_changed) || (!this.product_sn_image && prod_num_changed) ||
                (!box_num_changed && !prod_num_changed)
                ) && 
                this.$isRelianceClient()
            );
            if (hasScanIndicator) {
                return condition || (!this.serial_number1 && !this.serial_number2)
            }
            return condition
            }
            
        },
        isOpenEditButtonDisabled(){
            const not_allowed_orders = ['Receipt Challan', 'Returnable DC']
             //Receipt Challan means Transfer order and 'Returnable DC' is Repair Order
            if(this.selected[0] && this.selected[0].irrd_type == 'Replacement Order'){
                return this.selected.length !== 1
            }else{
                return this.selected.length !== 1 || not_allowed_orders.includes(this.selected[0].ird_type) || this.selected[0].scan_indicator === 'f'
            } 
        },
        isEditButtonAllowed(){
            const isAdmin = this.currentUser.roles.includes('admin');
            const isWarehouse = this.currentUser.roles.includes('warehouse_manager');
            const isSiteAdmin = this.currentUser.roles.includes('site_admin');
            const isCentralAdmin = this.currentUser.roles.includes('central_admin');
            const isOrgAllowed = this.$isRelianceClient() || this.$isWhirlpoolClient();

            return this.active_tab === 'Open PRDs' && isOrgAllowed && (isAdmin || isWarehouse || isSiteAdmin || isCentralAdmin) &&
                  (this.isActionAllowed(this.role) || isWarehouse || isSiteAdmin)
        },
        submitDisabled(){
            return !this.irrd_table_data.some(item => item.received_quantity)
        },
        computedHeaders() {
        if (this.$isRelianceClient() && this.active_tab === "Incomplete PRDs") {
            return this.headers.filter(header => header.key !== 'tag_number');
        } else {
            return this.headers.filter(header => header.key !== 'is_error');
        }
        },
        isSidebarExpanded() {
            return !this.$store.state.isSidebarExpanded;
        },
        widthStyle() {
            if(this.active_tab !== 'Approval'){
                return this.isSidebarExpanded ? { maxWidth: '185px !important', minWidth: '90px !important;' } : { maxWidth: '150px !important', minWidth: '90px !important;' };
            }else{
                return { maxWidth: '220px !important', minWidth: '300px !important;' }
            }
        },
        format_map_price: {
            get() {
            return this.map_edit ? this.formatCurrency(this.map_edit) : "";
            },
            set(value) {
            const numericValue = Number(value.replace(/[^0-9.-]+/g, ''));
            this.map_edit = isNaN(numericValue) ? '' : numericValue;
            }, 
        },
    },
    methods: {
        isActionAllowed(){
            return !isOnlyViewAction(this.role, 'PRD')
        },
        scrollToTOp(){
            window.scrollTo({
            top: 0,
            behavior: 'smooth',
          });
        },
        showAlert(alert_type, alert_message) {
            this.alert = true;
            this.alert_type = alert_type;
            this.alert_message = alert_message;
            this.alertTimeOut();
        },
        alertTimeOut() {
            setTimeout(() => {
            this.alert = false;
            },3000);
        },
        loadData(tab,action){
            if(action){
                this.search_tag = '';
            }
            this.loading = true;
            this.selected = [];
            this.table_data = [];
            this.page = 1;
            this.isFiltering = false;
            this.filterPage = 1;
            this.active_tab = tab;
            this.$store.commit('setActiveTab',{
                'active_tab' : tab
            })
            if( tab == "Incomplete PRDs"){
                this.headerText = "PRD";
                this.headers = [
                    { title: "PRD No.", key: "prd_number", minWidth:"120px" },
                    { title: "IRRD No.", key: "irrd_number", minWidth:"120px" },
                    { title: "IRRD Type", key: "irrd_type", minWidth:"140px" },
                    { title: "IRRD Date", key: "irrd_date", minWidth:"140px" },
                    { title: "IRD No.", key: "ird_number", minWidth:"120px" },
                    { title: "IRD Type", key: "ird_type", minWidth:"140px" },
                    { title: "IRD Date", key: "ird_date", minWidth:"120px" },
                    { title: "Tag ID", key: "tag_number", minWidth:"120px" },
                    { title: "Error!", key: "is_error",minWidth:"120px" },
                    { title: "Article ID", key: "sku_code", minWidth:"120px" },
                    { title: "Article Description", key: "sku_description", minWidth:"200px" },
                    { title: "Quantity", key: "quantity", minWidth:"100px" },
                    { title: "Serial No.1", key: "serial_number1", minWidth:"140px" },
                    { title: "Serial No.2", key: "serial_number2", minWidth:"140px" },
                    { title: "Action", key: "action",minWidth:"120px"  }
                ];
            } else if( tab == "Open PRDs"){
                this.headerText = "PRD";
                this.headers = [
                    { title: "PRD No.", key: "prd_number", minWidth:"120px,min",},
                    { title: "IRRD No.", key: "irrd_number", minWidth:"120px" },
                    { title: "IRRD Type", key: "irrd_type", minWidth:"140px" },
                    { title: "IRRD Date", key: "irrd_date", minWidth:"140px" },
                    { title: "IRD No.", key: "ird_number", minWidth:"120px" },
                    { title: "IRD Type", key: "ird_type", minWidth:"140px" },
                    { title: "IRD Date", key: "ird_date" , minWidth:"120px" },
                    { title: "Tag ID", key: "tag_number", minWidth:"120px" },
                    { title: "Article ID", key: "sku_code", minWidth:"120px" },
                    { title: "Article Description", key: "sku_description", minWidth:"200px" },
                    { title: "Quantity", key: "quantity", minWidth:"100px" },
                    { title: "Serial No.1", key: "serial_number1", minWidth:"140px" },
                    { title: "Serial No.2", key: "serial_number2", minWidth:"140px" },
                ];
            } else if( tab == "Pending For Approval"){
                this.headerText = "PRD";
                this.headers = [
                    { title: "Location", key: "location", minWidth:"120px,min",},
                    { title: "IRD", key: "ird", minWidth:"120px" },
                    { title: "Tag ID", key: "tag_number", minWidth:"120px" },
                    { title: "Article ID", key: "article_id", minWidth:"120px" },
                    { title: "Article Description", key: "article_description", minWidth:"200px" },
                    { title: "Lot ID", key: "lot_id", minWidth:"100px" },
                    { title: "Publish ID", key: "publish_id", minWidth:"140px" },
                    { title: "Recovery Benchmark Price", key: "recovery_benchmark_price", minWidth:"140px" },
                    { title: "Serial No.1", key: "serial_number", minWidth:"140px" },
                    { title: "Serial No.2", key: "serial_number2", minWidth:"140px" },
                    { title: "Approval Type", key: "approval_rule_type",minWidth:"120px"  },
                    { title: "Pending At", key: "next_approver_details",minWidth:"120px"  }
                ];
                this.fieldlist  = ['Tag ID','IRD','Lot ID','Publish ID','Pending At']
            }else {
                this.headerText = "PRD Deletion Approval";
                this.headers = [
                    { title: "PRD No.", key: "prd_number", minWidth:"120px" },
                    { title: "IRRD No.", key: "irrd_number", minWidth:"120px" },
                    { title: "IRRD Type", key: "irrd_type", minWidth:"140px" },
                    { title: "IRRD Date", key: "irrd_date", minWidth:"140px" },
                    { title: "IRD No.", key: "ird_number", minWidth:"120px" },
                    { title: "IRD Type", key: "ird_type", minWidth:"140px" },
                    { title: "IRD Date", key: "ird_date", minWidth:"120px" },
                    { title: "Tag ID", key: "tag_number", minWidth:"120px" },
                    { title: "Article ID", key: "sku_code", minWidth:"120px" },
                    { title: "Article Description", key: "sku_description", minWidth:"200px" },
                    { title: "Quantity", key: "quantity", minWidth:"100px" },
                    { title: "Serial No.1", key: "serial_number1", minWidth:"140px" },
                    { title: "Serial No.2", key: "serial_number2", minWidth:"140px" },
                    { title: "Location Code", key: "location_code", minWidth:"100px" },
                    { title: "Initiator", key: "initiator", minWidth:"100px" },
                ];
            }
            this.fetchIndexData();
            this.confirmedClicked = false;
        },
        fetchIndexData(){
            this.loading = true;
            const params = {
                // search : this.search_tag,
                page : this.page,
                per_page : this.pageSize
            }
            if(this.active_tab == "Incomplete PRDs" || this.active_tab == "Open PRDs"){
                if(this.selected_field == 'PRD No.'){
                    params.prd_number = this.search_tag
                }else if( this.selected_field == 'IRD No.'){                    
                  params.ird_number = this.search_tag
                }else {
                    params.serial_number = this.search_tag
                }
            } else if(this.active_tab == "Pending For Approval"){
                if(this.selected_field == 'Tag ID'){
                    params.tag_number = this.search_tag
                }else if(this.selected_field == 'IRD'){
                    params.ird = this.search_tag
                }else if(this.selected_field == 'Lot ID'){
                    params.lot_id = this.search_tag
                }else if(this.selected_field == 'Publish ID'){
                    params.publish_id = this.search_tag
                }else if(this.selected_field == 'Pending At'){
                    params.pending_at = this.search_tag
                }
            }else params.search = this.search_tag
           const status = this.active_tab === "Incomplete PRDs"
                            ? "Incomplete"
                            : this.active_tab === "Open PRDs"
                            ? "Open"
                            : this.active_tab === "Pending For Approval"
                            ? "pending_approval"
                            : "Pending Approval";
            this.$httpSecured
            .get("/api/v1/warehouse/prd?status="+status, { params } )
                .then(response => {
                if (response.data) {
                    this.table_data = response.data.pending_receipt_document_items
                    this.totalPages = response.data.meta.total_pages
                    this.totalCount = response.data.meta.total_count;
                    this.loading = false;
                } else {
                    this.loading = false;
                    this.showAlert("error", "No Data Found");
                }
            })
                .catch(error => {
                    this.showAlert("error", "Something went wrong from Network" + error);
                    this.loading = false;
            });
        },
        getFilterData(){
            this.$httpSecured
            .get("/api/v1/warehouse/prd/filters_data")
                .then(response => {
                if (response.data) {
                    this.irrdType_list = response.data.irrd_types
                } else {
                    this.showAlert("error", "No Data Found");
                }
            })
                .catch(error => {
                    this.showAlert("error", "Something went wrong from Network" + error);
            });
        },
        getInitiorsData(){
            this.$httpSecured
            .get("/api/v1/warehouse/prd/get_initiators")
            .then(response => {
                this.initiator_list = response.data.users
            })
            .catch(error => {
                this.showAlert("error", "Something went wrong from Network" + error);
            });
        },
        getApprovalLocation(){
            this.$httpSecured
            .get("/api/v1/warehouse/prd/get_approval_locations")
            .then(response => {
               this.approval_location_list = response.data.locations
            })
            .catch(error => {
                this.showAlert("error", "Something went wrong from Network" + error);
            });
        },
        filterListOfButtons() {
            this.filter_width = "950px"
            if(window.innerWidth > 1400 && window.innerWidth < 1500)
                this.filter_width = "1050px"
            else if(window.innerWidth >= 1500 && window.innerWidth < 1600)
                this.filter_width = "1150px"
            else if(window.innerWidth >= 1600)
                this.filter_width = "1250px"
            this.filterPopup = true;
            this.irrd_type = null;
            this.prd_number = '';
            this.subRequestId = '';
            this.reasonRefDocNo = '';
            this.RefDocNo = '';
            this.tag_id = '';
            this.article_id = '';
            this.serial_no = '';
            this.initiators = null
            this.approval_locations = null
        },
        applyFilterFunc(){
            this.filterPopup = false;
            this.search_tag = '';
            this.loading = true;
            this.isFiltering = true;
            const params = {    
                search : this.prd_number,
                irrd_number : this.reasonRefDocNo,
                ird_number : this.RefDocNo,
                irrd_type :this.irrd_type,
                tag_number : this.tag_id,
                sku_code : this.article_id, 
                serial_number : this.serial_no,
                page : this.filterPage,
                per_page : this.pageSize,
            }
            if(this.initiators)
                params.initiator = this.initiators
            if(this.approval_locations)
                params.approval_location = this.approval_locations
            const status = (this.active_tab == "Incomplete PRDs") ? 'Incomplete' : (this.active_tab == "Open PRDs") ? 'Open' : 'Pending Approval'; 
            this.$httpSecured
            .get("/api/v1/warehouse/prd?status="+status, { params } )
                .then(response => {
                if (response.data) {
                    this.table_data = response.data.pending_receipt_document_items
                    this.totalPages = response.data.meta.total_pages
                    this.totalCount = response.data.meta.total_count;
                    this.loading = false;
                    this.filterPopup = false;
                } else {
                    this.loading = false;
                    this.showAlert("error", "No Data Found");
                }
            })
                .catch(error => {
                    this.showAlert("error", "Something went wrong from Network" + error);
                    this.loading = false;
            });
        },
        handlePageChange(value) {
            this.page = value;
            if(this.isFiltering){
                this.filterPage = value;
                this.applyFilterFunc();
                return;
            }
            this.fetchIndexData();
        },
        handlePageSizeChange(size) {
            this.pageSize = size;
            this.page = 1
            this.filterPage = 1;
            if(this.isFiltering){
                this.applyFilterFunc();
                return;
            }
            this.fetchIndexData();
        },
        deleteItem(){
            this.message = "Are you sure you want to delete ?";
            this.okapproveconfirmpopup = true;
            this.deletion_remarks = '';
            this.action_name = 'delete';
        },
        approvalConfirmationCancel(){
            this.okapproveconfirmpopup = false;
            this.confirmedClicked = false;
        },
        approvalCinfirmed(){
            const selectedId=this.selected.map(x=> x.id);
            // selectedId.forEach( x => {params.ids.push(x)});
            if(this.action_name == 'delete'){
                this.$httpSecured
                .post("/api/v1/warehouse/prd/update_approval", { "ids" : selectedId, "reason_for_deletion" : this.deletion_remarks } )
                    .then(response => {
                    if (response.data) {
                        this.message = response.data.message;
                        this.action_name = 'success';
                        this.confirmedClicked = true;
                    } else {
                        this.showAlert("error", "No Data Found");
                    }
                })
                    .catch(error => {
                        this.$toast.error(error.response.data.error)
                });
            } else if(this.action_name == 'deletion_approval'){
                const params = {
                    "ids" : selectedId,
                    "remarks" : this.deletion_remarks
                }
                this.$httpSecured
                .delete("/api/v1/warehouse/prd/delete_items", { params } )
                    .then(response => {
                    if (response.data) {
                        this.message = response.data.message;
                        this.action_name = 'success';
                        this.confirmedClicked = true;
                    } else {
                        this.showAlert("error", "No Data Found");
                    }
                })
                    .catch(error => {
                        this.$toast.error(error.response.data.error)
                });
            }  else if (this.action_name == 'deletion_reject') {
                var params = {
                    "ids" : this.selected.map(item => item.approval_request_id),
                    "user_id" : this.$store.state.currentUser.id
                }
                params.rejected_on = new Date().toISOString()
                this.$httpSecured
                .put('/api/v1/approval_requests/bulk_update', { approval_request : params} )
                    .then(response => {
                    if (response.data) {
                        this.message = response.data.message;
                        this.action_name = 'success';
                        this.confirmedClicked = true;
                    } else {
                        this.showAlert("error", "No Data Found");
                    }
                })
                    .catch(error => {
                        this.$toast.error(error.response.data.error)
                });
            }    
        },
        okClicked(){
            this.okapproveconfirmpopup = false;
            setTimeout(() => {
                this.loadData(this.active_tab)
            }, 500);
        },
        creatPRD(item){
            if(item == 'Excel Upload'){
                this.excelUploadPopup = true;
                this.confirmButton='CONFIRM';
            } else if(item == 'IRD Number'){
                this.irdPopUp = true;
                this.irrdTableData = false;
                this.ird_width = "624px";
                this.irrd_selected = ''
                this.autoLoad = true
                this.$httpSecured
                .get("/api/v1/warehouse/prd/get_irrd_nums" )
                    .then(response => {
                    if (response.data) {
                        this.irrdList = response.data.irrd_nums
                        this.autoLoad = false
                    } else {
                        this.loading = false;
                        this.showAlert("error", "No Data Found");
                    }
                })
                    .catch(error => {
                        this.showAlert("error", "Something went wrong from Network" + error);
                        this.loading = false;
                });
            }
        },
        cancelUploadFile(){
            this.excelUploadPopup = false;
            this.number = 0;
            this.upload_file = '';
            this.uploadPercentage = 0;
            this.uploading = false;
        },
        confirmUploadFile(){
            this.number++;
            const formData = new FormData();
            formData.append('file' , this.upload_file);
            this.$httpSecured
            .post('/api/v1/items/create_bulk_inwards_file_import', formData )
                .then(response => {
                this.excelUploadPopup = false;
                this.showAlert('success', response.data.message);
                this.loadData(this.active_tab);
                })
                .catch(error => {
                    this.number = 0;
                    this.$toast.error(error.response.data.message);
                });  
        },
        changeFile(){
            if(this.upload_file == null){
                this.confirmButton = 'CONFIRM'
            }
        },
        uploadFile() {
            this.uploading = true;
            const reader = new FileReader();
            reader.onloadend = (event) => {
                setTimeout(() => {
                this.uploading = false;
                this.uploadPercentage = 0;
                }, 2000);
            };
            reader.onprogress = (event) => {
                if (event.lengthComputable) {
                const percentage = Math.round((event.loaded / event.total) * 100);
                this.uploadPercentage = percentage;
                this.number = 0;
                this.confirmButton = 'FINISH'
                }
            };
            reader.readAsDataURL(this.upload_file);
        },
        closeManualcreation(){
            this.manualCreationPopup = false;
            this.articleId = '';
            this.serialNo = '';
            this.quantity = '';
        },
        submitManualCreation(){
            const params = {
                articleId : this.articleId,
                serialNo : this.serialNo,
                quantity : this.quantity
            }
            this.$httpSecured
            .get("", { params } )
                .then(response => {
                if (response.data) {
                    this.message=response.data.message;
                    this.closeManualcreation();
                    this.confirmedClicked = true;
                    this.okapproveconfirmpopup = true;
                    this.action_name = 'success';
                } else {
                    this.showAlert("error", "No Data Found");
                }
            })
                .catch(error => {
                    this.showAlert("error", "Something went wrong from Network" + error);
            });
        },
        itemSubRequestDetailpopup(item){
            this.returnRequestId = item.return_sub_request_id
            this.dataDetailPopup = true;
            this.$httpSecured
            .get("/api/v1/warehouse/prd/"+item.id)
                .then(response => {
                if (response.data) {
                    this.item_details = response.data.item
                } else {
                    this.showAlert("error", "No Data Found");
                }
            })
                .catch(error => {
                    this.showAlert("error", "Something went wrong from Network" + error);
            });
        },
        itemIrrdDetailpopup(item,action){
          this.$store.commit("setPrdDetails",{
            action : action, 
            items : JSON.stringify(item),
            tab_name : (this.active_tab == "Incomplete PRDs") ? 'Incomplete' : (this.active_tab == "Open PRDs") ? 'Open' : 'Approval'
          });
          this.$router.push({ name: 'IrrdDetails' });
        },
        conditionDetails(){
            this.dataDetailPopup = false;
            this.conditionPopup = true;
        },
        backToRequestpage(){
            this.dataDetailPopup = true;
            this.conditionPopup = false;
        },
        showDataByIrd(){
            this.irrdTableData = true;
            this.ird_width = "790px";
            this.view_more = false;
            this.irrdHeaders = [
                { title: "Article ID", key: "sku_code" },
                { title: "Article Description", key: "sku_description" },
                { title: "IRRD Quantity", key: "irrd_qty" },
                { title: "Received Quantity", key: "received_quantity" },
            ];
            this.irrd_table_data = this.selected;
            const irrdItems = this.irrd_selected
            this.$httpSecured
                .get(`/api/v1/warehouse/prd/${irrdItems}/irrd_item_qty` )
                    .then(response => {
                    if (response.data) {
                        this.irrd_table_data = response.data.items
                    } else {
                        this.loading = false;
                        this.showAlert("error", "No Data Found");
                    }
                })
                    .catch(error => {
                        this.showAlert("error", "Something went wrong from Network" + error);
                        this.loading = false;
                });

        },
        addMoreColumn(){
            if(!this.view_more){
                this.ird_width = "960px";
                this.irrdHeaders = [
                    { title: "Tag ID", key: "tag_number" , width: "16%" },
                    { title: "Article ID", key: "sku_code" },
                    { title: "Serial Number", key: "serial_number_1" },
                    { title: "Article Description", key: "sku_description", width: "45%" },
                    { title: "IRRD Quantity", key: "quantity" },
                    { title: "Received Quantity", key: "received_quantity" },
                ];
            } else {
                this.ird_width = "790px";
                this.irrdHeaders = [
                    { title: "Article ID", key: "sku_code" },
                    { title: "Article Description", key: "sku_description", width: "50%" },
                    { title: "IRRD Quantity", key: "quantity" },
                    { title: "Received Quantity", key: "received_quantity" },
                ];
            }
            this.view_more = !this.view_more;
        },
        opendApprove(){
            this.openApprovelPopup = true;
        },
        writeOffYes(){
            this.openRaiseClaimPopup = true
            this.openApprovelPopup = false
        },
        raiseClaimYes(){
            this.openDebitNotePopup = true
            this.openRaiseClaimPopup = false
            this.enterd_vendor_code = ''
            this.debit_note_amount = ''
        },
        closeApprovalPopup(action){
            var params = {
                "ids" : this.selected.map(item => item.approval_request_id),
                "user_id" : this.$store.state.currentUser.id,
                params_hash : {
                    "allow_write_off": false
                }
            }
            params.approved_on = new Date().toISOString()
            if(action == 'raiseClaim'){
                params.params_hash.allow_write_off = true
                params.params_hash.allow_claim = true
                params.params_hash.vendor_code = ''
                params.params_hash.debit_amount = ''
            } else if(action == 'debitNote'){
                params.params_hash.allow_write_off = false
                params.params_hash.allow_claim = false
            } 
            this.callAppoveSubmitApi(params)
        },
        callAppoveSubmitApi(params){
            this.$httpSecured
            .put('/api/v1/approval_requests/bulk_update', { approval_request : params} )
            .then(response => {
                this.showAlert("success",response.data.message)
                this.loadData(this.active_tab)
                this.openDebitNotePopup = false
                this.openRaiseClaimPopup = false
                this.openApprovelPopup = false
            })
            .catch(error => {
                this.openDebitNotePopup = false
                this.openRaiseClaimPopup = false
                this.openApprovelPopup = false
                this.showAlert("error", error.response.data.error);
            });
        },
        OpenReject(){
            this.okapproveconfirmpopup = true;
            this.message = "Are you sure want to reject this delete aprroval request!"
            this.action_name = 'deletion_reject';
        },
        download_incomplete_file(){
            const selected_id = this.selected.map( x=> x.id)
            const params = {
                "ids" : selected_id
            }
            this.$httpSecured.
            get("/api/v1/warehouse/prd/download_items",{ params }
            )
            .then(response => {
            if (response.data) {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `PRD-Incomplete-Items_prd.csv`);
                document.body.appendChild(link);
                link.click();
                this.message = "CSV for prd ( ";
                for( var i=0;i<Math.min(this.selected.length,3); i++){
                    if( i==0){
                        this.message += this.selected[i].prd_number
                    } else {
                        this.message +=", " + this.selected[i].prd_number
                    }
                }
                if(this.selected.length>3){
                    this.message +=",... "
                }
                this.message+=" ) Successfully Downloaded.";
                this.okapproveconfirmpopup = true;
                this.action_name = 'success';
                this.confirmedClicked = true;
            }
            })
            .catch(error => {
                this.$toast.error(error.response.data.error)
            });
        },
        createIrd(){
            const irrdItems = this.irrd_selected;
            const itemsToSend = this.irrd_table_data.map(item => ({
                sku_code: item.sku_code,
                received_qty: Number(item.received_quantity)
            }));
            const RequestBody = {
                items: itemsToSend
            };
            this.$httpSecured
            .put(`/api/v1/warehouse/prd/${irrdItems}/create_ird`, RequestBody )
                .then(response => {
                    if (response.data) {
                        this.message = response.data.message;
                        this.irdPopUp = false
                        this.action_name = 'success';
                        this.okapproveconfirmpopup = true;
                        this.confirmedClicked = true;
                    } else {
                        this.showAlert("error", "No Data Found");
                    }
                })
                    .catch(error => {
                        this.$toast.error(error.response.data.error)
                });
        },
        onKeyDown(item) {
            const regex = /^(?!0)\d*$/;
            const currentValue = item.received_quantity;
            setTimeout(() => {
                if (!regex.test(item.received_quantity)) {
                    item.received_quantity = currentValue.replace(/\D/g, '');
                }
            }, 0);
        },
        openEditSerialNumberPopup(){
            this.updateSerialNumberPopup = true;
            this.serial_number1 = this.selected[0].serial_number1;
            this.article_id_edit = this.selected[0].sku_code;
            this.map_edit = this.selected[0].map;
            this.serial_number2 = this.selected[0].serial_number2
            this.box_sn_image = this.product_sn_image = null
            this.number = 0
        },
        closeUpdateSerialNumberPop(){
           this.updateSerialNumberPopup = false;
           this.serial_number1 = '';
           this.serial_number2 = '';
        },
        updateSerialNumber(){
            this.number++;
            let RequestBody;
            if(this.selected[0].irrd_type == 'Replacement Order'){
                RequestBody = new FormData()
                if(this.selected[0].irrd_type == 'Replacement Order' && this.selected[0].scan_indicator === 'f'){
                   RequestBody.append('article_id', this.article_id_edit)
                   RequestBody.append('map', this.map_edit) 
                }else{
                    RequestBody.append('serial_number1', this.serial_number1 ? this.serial_number1 : '')
                    RequestBody.append('serial_number2', this.serial_number2 ? this.serial_number2 : '')
                    RequestBody.append('article_id', this.article_id_edit)
                    RequestBody.append('map', this.map_edit)
                    RequestBody.append('serial_number1_approval_attachment', this.box_sn_image)
                    RequestBody.append('serial_number2_approval_attachment', this.product_sn_image)
                }
            }else{
                RequestBody = new FormData()
                RequestBody.append('serial_number1', this.serial_number1 ? this.serial_number1 : '')
                RequestBody.append('serial_number2', this.serial_number2 ? this.serial_number2 : '')
                RequestBody.append('serial_number1_approval_attachment', this.box_sn_image)
                RequestBody.append('serial_number2_approval_attachment', this.product_sn_image)
            }
            this.$httpSecured
            .put(`/api/v1/warehouse/prd/${this.selected[0].id}/update_serial_number`, RequestBody)
            .then(response => {
              if (response.status === 200) {
                this.updateSerialNumberPopup = false
               const prd_number = response.data.prd_number
               this.message = prd_number ? `${prd_number} - Request is Successfully Submitted & Sent For Approval` : "Successfully updated";
               this.action_name = 'success';
                this.okapproveconfirmpopup = true;
                this.confirmedClicked = true;
                this.number = 0;
              } else {
                this.showAlert("error", "Something went Wrong !!");
                this.number = 0;
              }
            })
            .catch(error => {
              this.showAlert("error", error.response.data.error);
              this.number = 0;
            });
        },
      formatCurrency(value) {
        let number = typeof value === 'string' ? value.replace(/,/g, '') : value
        return Number(number) ?  Number(number).toLocaleString('en-IN') : null;
      },
    },
}
</script>

<style scoped>
    .custom-control_outlined .v-expansion-panel:before {
        box-shadow: none;
    }
    .custom-control_outlined button {
        min-height: 56px;
        border-width: 1px;
        border-color: rgba(0,0,0,.42);
        border-style: solid;
    }

    .custom-control_outlined button:focus {
        outline: none;
    }
    .v-dialog:has(.filter-data){
        justify-content: right;
        align-items: baseline;
        top: 14rem;
    }  
    
    .itemPopUp .col-6{
        padding : 6px !important;
    }


    .item-selected{
        margin-top: 23px;
        position: absolute;
        left: 41%;
    }
    @media (max-height: 1104px) {
        .PaddingItemPerPage{
            padding: 8px !important;
        }
    }
    @media (min-height: 1126px) {
        .PaddingItemPerPage{
            padding: 24px !important;
        }
    }
    .v-data-table {
      height: calc(var(--vh, 1vh) * 100 - 340px) !important;
    }
    .text-break {
        display: none;
    }
    @media (max-width: 1550px) {
    .text-break {
        display: block;
    }
    }
    @media (min-width: 1300px) and (max-width: 1550px) {
        .SelectItem, .SearchItem {
            max-width: 110px !important;
            min-width: 90px !important;
        }
    }
 .filter_ui{
    margin-right: 5px !important;
    margin-top: 12px !important;
 }
 .file_name_css{
    border: 1px solid;
    border-radius: 6px;
    padding: 6px;
 }
</style>